module.exports = __webpack_public_path__ + "img/1.bcc847f8.png";